import type { Role } from '@/lib/auth-context';
import { fetchApi } from '@/services/api-client';

export const AUDIT_LOGS_PATH = '/admin/audit-logs';

export type AuditLog = {
  id: string;
  actorId: string;
  actorEmail: string;
  actorRole: Role;
  method: string;
  path: string;
  action: string;
  targetId: string | null;
  payload: unknown;
  payloadRestricted?: boolean;
  statusCode: number;
  createdAt: string;
};

export type AuditLogListResponse = {
  data: AuditLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type AuditLogSortKey = 'createdAt' | 'actor' | 'action' | 'target' | 'status';

export type AuditLogFilters = {
  page?: number;
  limit?: number;
  actorEmail?: string;
  action?: string;
  from?: string;
  to?: string;
  sortBy?: AuditLogSortKey;
  sortDir?: 'asc' | 'desc';
};

export const auditLogsApi = {
  list: (filters: AuditLogFilters = {}) => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.actorEmail) params.append('actorEmail', filters.actorEmail);
    if (filters.action) params.append('action', filters.action);
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortDir) params.append('sortDir', filters.sortDir);
    const qs = params.toString();
    return fetchApi<AuditLogListResponse>(`${AUDIT_LOGS_PATH}${qs ? `?${qs}` : ''}`);
  },
};
